import React from 'react';
import {
  EditContext,
  EditContextValidatedType,
} from '@xingternal/pages-common';

export const useEditContext = (): EditContextValidatedType => {
  const context = React.useContext(EditContext);

  if (!context) {
    throw new Error('No host context found. Please setup the EditContext');
  }

  return context as EditContextValidatedType;
};
